import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { usePostHog } from "posthog-js/react";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import { updateContactUsEmployer } from "../../../redux/actions/dialog_action";
import EmployerLandingContactUsDialog from "../EmployerLandingContactUsDialog/EmployerLandingContactUsDialog";
import content_my from "./content_my.json";
import content_sg from "./content_sg.json";
import {
  ButtonStyled,
  CardContainer,
  CardListContainer,
  CardText,
  CardTextContainer,
  CheckIcon,
  CustomButtonWrap,
  CustomDescription,
  CustomIcon,
  CustomPackageCard,
  CustomTitle,
  FeatureDetailText,
  FeatureItem,
  FeatureList,
  FeatureMainText,
  FeatureTextWrap,
  FeatureTitle,
  GridContainerStyled,
  HighlightItem,
  HighlightList,
  MoreFeaturesButton,
  PackageDivider,
  PopularCard,
  PopularTag,
  SectionGrid,
  TaglineTitle,
  WhatsAppIconCircle,
  WhatsAppPromoCard,
  WhatsAppPromoContent,
  WhatsAppPromoNote,
  WhatsAppPromoTitle
} from "./styles";

export default function SubEmployerHiringPackage(props) {
  const {} = props;
  const [solutions, setSolutions] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);
  const [expandedCards, setExpandedCards] = useState({});

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    // const responseApi = await dispatch(fetchEmployerSolutions());

    const isMalaysia = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";
    const response = isMalaysia ? content_my : content_sg;

    const { solutions, solutionsCard } = response || {};
    setSolutions(solutions);
    setSolutionsCard(solutionsCard);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const buttonCTA = "Buy Now";
  const posthog = usePostHog();

  function triggerEmployerSignUp(buttonColour, section) {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: section ? section : "pricing_page_packages",
    });
  }

  function toggleExpandedCard(cardIndex) {
    setExpandedCards((prev) => ({
      ...prev,
      [cardIndex]: !prev[cardIndex],
    }));
  }

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      {solutions?.map((solution, index) => (
        <TaglineTitle
          dangerouslySetInnerHTML={{ __html: solution?.title }}
        ></TaglineTitle>
      ))}

      <CardContainer>
        {solutionsCard?.map((cards, cardIndex) => {
          const isExpanded = expandedCards[cardIndex];
          const features = cards?.features || [];
          const visibleFeatures = isExpanded ? features : features.slice(0, 3);
          const hiddenFeaturesCount = Math.max(features.length - 3, 0);
        
        
        return (
          <>
          {cards?.type === "custom" ? (
            <CustomPackageCard key={cardIndex}>
              <CustomIcon><CardGiftcardIcon /></CustomIcon>
              <CustomTitle>{cards?.title}</CustomTitle>
              <CustomDescription>{cards?.description}</CustomDescription>
              <CustomButtonWrap>
              <ButtonStyled 
                onClick={() => 
                  dispatch(
                    updateContactUsEmployer({
                      state: true,
                      origin: cards?.trackingSection || "pricing_page_packages_custom",
                      prefilled: "Job Posting",
                      message: "I want to ask about custom hiring package"
                    })
                  )
              }
              isPopular={false}
              >{cards?.buttonCTA || "Contact Us"}
              </ButtonStyled>
              </CustomButtonWrap>
            </CustomPackageCard>
          ) : cards?.isPopular ? (
              <>
                <PopularCard>
                  <PopularTag>MOST POPULAR</PopularTag>
                  <CardListContainer
                    key={cardIndex}
                    cardNumber={cardIndex}
                    isPopular={cards?.isPopular}
                  >
                    <CardTextContainer>
                      {/* section 1 */}
                    <SectionGrid sx={{ alignItems: "flex-start", gap: "4px" }}>
                      <SectionGrid 
                        sx={{ 
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          gap: "8px" 
                        }}
                      >
                        <CardText
                          type={"title"}
                          cardNumber={cardIndex}
                          dangerouslySetInnerHTML={{ __html: cards?.title }}
                        ></CardText>

                          {cards?.savedPercentage > 0 && (
                            <CardText type={"savedPercentage"} sx={{ background: "#D1EAC9" }}>
                            {`Save ${cards?.savedPercentage}%`}
                        </CardText>
                          )}
                      </SectionGrid>

                      <CardText
                          type={"desc"}
                          cardNumber={cardIndex}
                          dangerouslySetInnerHTML={{
                            __html: cards?.description,
                          }}
                        ></CardText>
                      </SectionGrid>

                      {/* section 2 */}
                      <SectionGrid sx={{ alignItems: "flex-start", gap: "12px" }}>
                      <SectionGrid sx={{ alignItems: "flex-start", gap: "8px" }}>
                        <CardText type={"price"}>
                          <b>{cards?.price}</b> / credit
                        </CardText>

                        <CardText type={"total"} sx={{ height: "18px" }}>
                          {cards?.total !== "0"
                            ? `${cards?.total} total`
                            : null}
                        </CardText>
                        </SectionGrid>
                        <PackageDivider/>
                        <HighlightList>
                          {cards?.highlights?.map((highlight, highlightIndex) => (
                            <HighlightItem key={highlightIndex}>{highlight}</HighlightItem>
                          ))}
                        </HighlightList>

                        <FeatureList>
                          <FeatureTitle>INCLUDES</FeatureTitle>

                          {visibleFeatures.map((feature, featureIndex) => (
                            <FeatureItem key={featureIndex}>
                              <CheckIcon><span>✓</span></CheckIcon>
                              <FeatureTextWrap>
                                <FeatureMainText>
                                  {typeof feature === "string" ? feature : feature?.title}
                                </FeatureMainText>
                                {typeof feature !== "string" && feature?.detail && (
                                  <FeatureDetailText>{feature.detail}</FeatureDetailText>
                                )}
                              </FeatureTextWrap>
                            </FeatureItem>
                          ))}

                          {hiddenFeaturesCount > 0 && (
                            <MoreFeaturesButton onClick={() => toggleExpandedCard(cardIndex)}>
                              {isExpanded ? "Show Less" : `+${hiddenFeaturesCount} more features`}
                            </MoreFeaturesButton>
                          )}
                        </FeatureList>
                      </SectionGrid>

                      {/* section 3 */}
                      <SectionGrid sx={{ gap: "16px", marginTop: "auto" }}>
                        <ButtonStyled
                          onClick={() =>
                            triggerEmployerSignUp(
                              "black",
                              cards?.trackingSection
                            )
                          }
                          isPopular={cards?.isPopular}
                        >
                          {buttonCTA}
                        </ButtonStyled>
                      </SectionGrid>
                    </CardTextContainer>
                  </CardListContainer>
                </PopularCard>
              </>
            ) : (
              <>
                <CardListContainer key={cardIndex} cardNumber={cardIndex}>
                  <CardTextContainer>
                    {/* section 1 */}
                  <SectionGrid sx={{ alignItems: "flex-start", gap: "6px"}}>
                    <SectionGrid 
                        sx={{ 
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          gap: "8px" 
                        }}
                      >
                        <CardText
                          type={"title"}
                          cardNumber={cardIndex}
                          dangerouslySetInnerHTML={{ __html: cards?.title }}
                        ></CardText>

                          {cards?.savedPercentage > 0 && (
                            <CardText type={"savedPercentage"} sx={{ background: "#D1EAC9" }}>
                            {`Save ${cards?.savedPercentage}%`}
                        </CardText>
                          )}
                      </SectionGrid>

                      <CardText
                          type={"desc"}
                          cardNumber={cardIndex}
                          dangerouslySetInnerHTML={{
                            __html: cards?.description,
                          }}
                        ></CardText>
                      </SectionGrid>

                    {/* section 2 */}
                    <SectionGrid sx={{ alignItems: "flex-start", gap: "12px" }}>
                    <SectionGrid sx={{ alignItems: "flex-start", gap: "8px" }}>
                      <CardText type={"price"}>
                        <b>{cards?.price}</b> / credit
                      </CardText>

                      <CardText type={"total"} sx={{ minHeight: "18px" }}>
                        {cards?.total !== "0" ? `${cards?.total} total` : ""}
                      </CardText>
                      </SectionGrid>
                      <PackageDivider/>
                      <HighlightList>
                          {cards?.highlights?.map((highlight, highlightIndex) => (
                            <HighlightItem key={highlightIndex}>{highlight}</HighlightItem>
                          ))}
                        </HighlightList>

                        <FeatureList>
                          <FeatureTitle>INCLUDES</FeatureTitle>

                          {visibleFeatures.map((feature, featureIndex) => (
                            <FeatureItem key={featureIndex}>
                              <CheckIcon><span>✓</span></CheckIcon>
                              <FeatureTextWrap>
                               <FeatureMainText>
                                  {typeof feature === "string" ? feature : feature?.title}
                                </FeatureMainText>
                                {typeof feature !== "string" && feature?.detail && (
                                  <FeatureDetailText>{feature.detail}</FeatureDetailText>
                                )}
                              </FeatureTextWrap>
                            </FeatureItem>
                          ))}

                          {hiddenFeaturesCount > 0 && (
                            <MoreFeaturesButton onClick={() => toggleExpandedCard(cardIndex)}>
                              {isExpanded ? "Show Less" : `+${hiddenFeaturesCount} more features`}
                            </MoreFeaturesButton>
                          )}
                        </FeatureList>
                    </SectionGrid>

                    {/* section 3 */}
                    <SectionGrid sx={{ gap: "16px", marginTop: "auto" }}>
                      <ButtonStyled
                        onClick={() =>
                          triggerEmployerSignUp("white", cards?.trackingSection)
                        }
                        isPopular={cards?.isPopular}
                      >
                        {buttonCTA}
                      </ButtonStyled>
                    </SectionGrid>
                  </CardTextContainer>
                </CardListContainer>
              </>
            )}
          </>
        );
        })}
      </CardContainer>

      <WhatsAppPromoCard>
        <WhatsAppIconCircle>
          <WhatsAppIcon />
        </WhatsAppIconCircle>

        <WhatsAppPromoContent>
          <WhatsAppPromoTitle>
            You'll also get 3 Free Internship Tokens + 3 Specialty Job Credits* when you opt-in to our WhatsApp channel!
          </WhatsAppPromoTitle>

          <WhatsAppPromoNote>
            *Specialty Job Credits apply only to in-store & on-ground Retail, Hospitality & F&B roles.
          </WhatsAppPromoNote>
        </WhatsAppPromoContent>
      </WhatsAppPromoCard>
      <EmployerLandingContactUsDialog />
    </GridContainerStyled>
  );
}
